// libs/core/src/lib/decorators/cache-active-promise.ts
function CacheActivePromise(keyExtractor) {
  const cacheStorage = /* @__PURE__ */ new WeakMap();
  const getCache = (ctx) => {
    let cache = cacheStorage.get(ctx);
    if (!cache) {
      cache = /* @__PURE__ */ new Map();
      cacheStorage.set(ctx, cache);
    }
    return cache;
  };
  return function(_, fieldName, propertyDescriptor) {
    const method = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
      const cache = getCache(this);
      const key = keyExtractor ? keyExtractor(...[this, ...args]) : JSON.stringify(args, stringifyReplacer);
      if (cache.has(key)) {
        return cache.get(key);
      }
      const result = method.apply(this, args).finally(() => cache.delete(key));
      cache.set(key, result);
      return result;
    };
    return propertyDescriptor;
  };
}
function stringifyReplacer(_, value) {
  if (typeof value === "bigint") {
    return value.toString();
  }
  return value;
}
export {
  CacheActivePromise
};
//# sourceMappingURL=index.esm.js.map
